import React from 'react';
import { useTheme } from '@mui/material/styles';
import './RoleFilter.css';

/**
 * Role chip row — same layout as client CategoryFilter, blue/grey role styling.
 * @param {{ id: string, label: string, count: number }[]} roles
 * @param {string|null | undefined} selectedRoleId e.g. 'all' | 'owner' | 'manager' | 'employee'
 */
const RoleFilter = ({ roles = [], selectedRoleId, onRoleClick }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const cssVars = {
    '--as-text': isDark ? '#e5e7eb' : '#0f172a',
    '--as-muted': isDark ? '#94a3b8' : '#64748b',
    '--role-filter-primary': '#488aec',
    '--role-filter-inactive-bg': isDark ? 'rgba(148, 163, 184, 0.12)' : '#f1f5f9',
    '--role-filter-inactive-text': isDark ? '#94a3b8' : '#64748b',
    '--role-filter-inactive-border': isDark ? 'rgba(148, 163, 184, 0.22)' : '#e2e8f0',
    '--role-filter-inactive-hover-bg': isDark ? 'rgba(148, 163, 184, 0.2)' : '#e2e8f0',
    '--role-filter-inactive-hover-text': isDark ? '#cbd5e1' : '#475569',
  };

  const sorted = [...roles].sort((a, b) => b.count - a.count);

  return (
    <div className="categoryFilter roleFilter" style={cssVars}>
      <div className="categoryFilterHeader">
        <svg className="categoryFilterIcon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
        <span className="categoryFilterLabel">Roles</span>
      </div>

      <div className="categoryFilterChips">
        {sorted.map((role) => (
          <button
            key={role.id}
            type="button"
            className={`categoryFilterChip ${selectedRoleId === role.id ? 'active' : ''}`}
            onClick={() => onRoleClick(role.id)}
          >
            {role.label}
            <span className="categoryFilterChipCount">{role.count}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RoleFilter;
